import * as _ from 'lodash-es';
import { AdminLotList } from '../model/adminLot-list';
import { AdminLotBuilder } from './adminLot-builder';
export class AdminLotBuilderList {
    static buildAdminLotList(data) {
        let adminLot = new AdminLotList();
        adminLot = Object.assign({}, data);
        adminLot.lots = _.map(data.lots, (adminLot) => {
            return AdminLotBuilder.buildAdminLot(adminLot);
        });
        return adminLot;
    }
}
//# sourceMappingURL=adminLotList-builder.js.map